const productCard = () => {
  const cards = document.getElementsByClassName('akb-product-card');

  let isMobile = window.innerWidth <= 1068 ? true : false;


  function addEventListeners() {
    for ( const card of cards ) {
      card.addEventListener('mouseover', showBtn);
      card.addEventListener('mouseleave', hideBtn);
    }
  }

  function removeEventListeners() {
    for ( const card of cards ) {
      card.removeEventListener('mouseover', showBtn);
      card.removeEventListener('mouseleave', hideBtn);
    }
  }
  

  function showBtn() {
    let self = this;
    let childBtn = self.querySelector('.akb-add-btn');
    if ( childBtn && childBtn.classList.contains('anim-hide') ) {
      childBtn.classList.remove('anim-hide');
    }
  }

  function hideBtn() {
    let self = this;
    let childBtn = self.querySelector('.akb-add-btn');
    if ( childBtn && !childBtn.classList.contains('anim-hide') ) {
      childBtn.classList.add('anim-hide');
    }    
  }


  function handleResize() {
    isMobile = window.innerWidth <= 1068 ? true : false;

    if ( !isMobile ) {
      addEventListeners();
    }
  
    if ( isMobile ) {
      removeEventListeners();
    }
  }

  window.addEventListener('resize', handleResize);

  handleResize();
}

productCard();